import { html, ViewTemplate, when } from '@microsoft/fast-element';
import type { UserManagement } from './user-management';
import { Users, Profiles, EntityManagement } from '@genesislcap/foundation-entity-management';
import { PROFILE_RIGHTS } from '../../utils/enums/generic.enum';

Users;
Profiles;
EntityManagement;
export const UserManagementTemplate: ViewTemplate = html<UserManagement>`
  <div class="container">
    <zero-tabs class="protected-tabs" activeid="companyTabContent">
      <span slot="start">Admin</span>
      ${when(
        (x) => x.isAdmin,
        html`
          <zero-tab id="companyTabContent" slot="companyTabContent">Companies</zero-tab>
        `,
      )}
      <zero-tab id="userTab" slot="userTab">Users</zero-tab>
      ${when(
        (x) => x.isAdmin,
        html`
          <zero-tab id="profileTab" slot="profileTab">Roles</zero-tab>
          <zero-tab id="auditTab" slot="auditTab">Audit Trail</zero-tab>
        `,
      )}
      ${when(
        (x) =>
          x.isAdmin &&
          x.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.REMAP_SUB_CHANGE),
        html<UserManagement>`
          <zero-tab id="thirdPartyTab" slot="thirdPartyTab">Third Party Integration</zero-tab>
        `,
      )}
      ${when(
        (x) => x.isAdmin,
        html`
          <zero-tab-panel id="companyTabContent" slot="companyTabContent">
            <company-management></company-management>
          </zero-tab-panel>
        `,
      )}
      <zero-tab-panel id="userTabContent" slot="userTabContent">
        <cascade-user-management></cascade-user-management>
      </zero-tab-panel>
      ${when(
        (x) => x.isAdmin,
        html`
          <zero-tab-panel id="profileTabContent" slot="profileTabContent">
            <entity-management
              :gridOptions=${(x) => x.gridOptions}
              resourceName="ALL_PROFILES"
              title="Profile Management"
              entityLabel="Profile"
            ></entity-management>
          </zero-tab-panel>
          <zero-tab-panel id="auditTabContent" slot="auditTabContent">
            <audit-grid></audit-grid>
          </zero-tab-panel>
        `,
      )}
      ${when(
        (x) =>
          x.isAdmin &&
          x.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.REMAP_SUB_CHANGE),
        html<UserManagement>`
          <zero-tab-panel id="thirdPartyTabContent" slot="thirdPartyTabContent">
            <third-party-management></third-party-management>
          </zero-tab-panel>
        `,
      )}
    </zero-tabs>
  </div>
`;
